import BaseBlockContent from '@sanity/block-content-to-react'
import React from 'react'
import Figure from './figure'
import FileDownload from './fileDownload'
import getYouTubeId from 'get-youtube-id'
import YouTube from 'react-youtube'

const serializers = {
  
  types: {
    block (props) {
      switch (props.node.style) {
        case 'h1':
          return <h1 className>{props.children}</h1>

        case 'h2':
          return <h2 className>{props.children}</h2>

        case 'h3':
          return <h3 className>{props.children}</h3>

        case 'h4':
          return <h4 className>{props.children}</h4>

        case 'blockquote':
          return <blockquote className>{props.children}</blockquote>

        default:
          return <p className>{props.children}</p>
      }
    },
    
    figure (props) {
      console.log('FIgure',props)
      return <Figure {...props.node} />
    },
    // slideshow (props) {
    //   return <Slideshow {...props.node} />
    // },
    fileDownload (props) {
      return <FileDownload {...props.node} />
    },
    youtube: ({node}) => {
      const { url } = node
      const id = getYouTubeId(url)
      return (<YouTube videoId={id} />)
    }
  },
  marks: {
    link: ({mark, children}) => {
      // Read https://css-tricks.com/use-target_blank/
      const { blank, href, displayAsButton } = mark
      const classStyle = displayAsButton ? "button" : ""
      return blank ?
        <a href={href} target="_blank" rel="noopener noreferrer" className={classStyle}>{children}</a>
        : <a href={href} className={classStyle}>{children}</a>
    },
  }
}

const BlockContent = ({ blocks }) => <BaseBlockContent blocks={blocks} serializers={serializers} />

export default BlockContent
